/**
 * Created by Stefano Mandruzzato on 20/11/18.
 */

export default class ReduxTodoController {
  disconnect;
  $ngRedux;

  constructor($log, $ngRedux, iceApplicationPreferences, $translate, $state, $scope, LmrcApiService, queryParamGetter) {
    'ngInject';

    this.logger = $log.getInstance('ExternalHeaderController');
    this.$ngRedux = $ngRedux;
    this.icePrefs = iceApplicationPreferences;
    this.$translate = $translate;
    this.$state = $state;
    this.$scope = $scope;
    this._queryParamGetter = queryParamGetter;
    this._lmrcApiService = LmrcApiService;
  }

  $onInit () {
    this.logger.debug('$onInit', this.$ngRedux);

    let actionCreators = { };
    this.disconnect = this.$ngRedux.connect(this._mapStateToThis.bind(this), actionCreators)(this);

    // TODO connect preferences with ReDux !
    this._applyPreferences();
    this.$scope.$on(this.icePrefs.getPreferencesChangedNamespace(), this._applyPreferences.bind(this));
  }

  _mapStateToThis (state) {
    return {
      currentLanguage: this.$translate.use(),
      languages: {
        'it_IT': { id: 'it_IT', label: 'Italiano' },
        'en_EN': { id: 'en_EN', label: 'English' }
      }
    };
  }

  changeLanguage ($event) {
    this.$translate.use($event.id);
    this.currentLanguage = this.$translate.use();
  }

  navbarBrandAction () {
    this.$state.go('external.insert-email');
  }

  _applyPreferences () {
    let prefs = this.icePrefs;

    this.pref = {
      brandText: prefs.getPref('layouts.main.main-header.brand-logo.txt'),
      brandImage: prefs.getPref('layouts.main.main-header.brand-logo.img'),
      translationEnabled: prefs.getPref('layouts.main.translation.enabled') === "true"
    };
    const customizationId = _.trim(this._queryParamGetter('ui', true));
    if (customizationId) {
      const that = this;
      this._lmrcApiService.getCustomization(customizationId)
        .then(resp => {
          that.logger.debug("getCustomization response", resp.data);
          // {
          //   "externalDomain": "gmail.com",
          //   "customCss": null,
          //   "logoPath": null,
          //   "skipTermsAndConditionsPhase": false,
          //   "termsOfServicePath": null,
          //   "conditionContractPath": null,
          //   "privacyPolicyPath": null
          // }
          if (resp.data.logoPath) {
            that.logger.debug("getCustomization setting logoPath", resp.data.logoPath);
            that.pref.brandImage = resp.data.logoPath;
            that.logger.debug("logoPath CHANGED")
          }
          if(resp.data.customCss){
            that.logger.debug("getCustomization setting customCss", resp.data.customCss);
            // thanks to the good lord https://stackoverflow.com/a/707580/4251820
            var styles = resp.data.customCss;
            var styleSheet = document.createElement("style")
            styleSheet.type = "text/css"
            styleSheet.innerText = styles
            document.head.appendChild(styleSheet)
          }
        }, err => {
          that.logger.debug("getCustomization failed, using default conf", err);
        });
    } else{
      logger.debug("getCustomization no customization")
    }
    this.logger.debug('_applyPreferences', this.pref);

  }


  $onDestroy () {
    this.disconnect();
  }

}



// WEBPACK FOOTER //
// ./client/app/layout/external-layout/external-header/external-header.controller.js